import { Col, Row, Form, Breadcrumb, Switch, Input, Select, Tabs } from "antd";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { CategoryType } from "./CategoryType";
import { editCategory, createCategory } from "../../api/category";
import { Link } from "react-router-dom";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import { message } from "antd";
import InputName from "../UI/InputNumberComponent/InputName";
import { InputNumber } from "../UI/InputNumberComponent/inputnumber";
import TextArea from "../UI/InputNumberComponent/TextArea";

function AddEditCategory() {
  const location = useLocation();
  const category = location?.state?.category;
  const formatedPriceScheme = location?.state?.formatedPriceScheme;
  const loadingPriceScheme = location?.state?.loadingPriceScheme;

  const [t] = useTranslation("common");
  const [, setError] = useState("");
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [key, setKey] = useState("1");
  const isEdit = () => {
    return !!id;
  };
  const onChange = (key: string) => {
    setKey(key);
  };

  const onError = (error: any, variables: CategoryType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createCategory" : "editCategory",
    !isEdit()
      ? (category: CategoryType) => createCategory(category)
      : (category: CategoryType) => editCategory(id, category),
    {
      onSuccess: (res) => {
        navigate("/cactegory");
        message.success("Saved successfully!");
      },
      onError,
    }
  );
  const handleFinish = () => {
    const newCategory = form.getFieldsValue();
    for (const key in newCategory) {
      if (newCategory[key] === undefined) {
        if (key === "isActive") {
          newCategory[key] = true;
        } else {
          newCategory[key] = null;
        }
      } else if (
        typeof newCategory[key] === "string" &&
        newCategory[key].trim() === ""
      ) {
        newCategory[key] = null;
      }
    }
    mutateCreateUpdate(newCategory);
  };
  const [name, setName] = useState(false);
  const [, setOrder] = useState(false);
  const [editStatus] = useState(isEdit());
  const handleNameChange = (event: any) => {
    setName(event);
  };
  useEffect(() => {
    if (editStatus) {
      setName(true);
      setOrder(true);
    }
  }, [editStatus]);

  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,
    },
  ];

  return (
    <>
      <Row>
        <Col
          offset={1}
          span={20}
          style={{
            marginBottom: "10px",
          }}
        >
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("inventory")}</>,
              },
              {
                title: <Link to="/cactegory">{t("categories-list")}</Link>,
              },
              {
                title: (
                  <>
                    {isEdit()
                      ? `${t("edit-category")}`
                      : `${t("add-category")}`}
                  </>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("general-information")}
                  </span>
                ),
              },
            ]}
          />
        </Col>

        {isEdit() ? (
          <Col offset={1} span={20} className="editTitle">
            {category?.name}
          </Col>
        ) : (
          <Col offset={1} span={20} className="editTitle">
            {t("add-category")}
          </Col>
        )}
      </Row>
      <Col offset={1} span={22}>
        <Tabs
          className="ant-tab"
          defaultActiveKey="1"
          activeKey={key}
          items={items}
          onChange={onChange}
        />
      </Col>

      <Col offset={1} span={22}>
        <Form
          layout="vertical"
          form={form}
          id="categoryForm"
          onFinish={handleFinish}
        >
          <Row style={{ minHeight: "55vh" }}>
            <Col span={6}>
              <Form.Item
                label={`${t("status")}`}
                initialValue={isEdit() ? category?.isActive : true}
                name="isActive"
                valuePropName="checked"
              >
                <Switch
                  data-testid="switch-toggle"
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  disabled={isEdit() ? false : true}
                />
              </Form.Item>

              <Form.Item
                initialValue={category?.name}
                name="name"
                label={`${t("category-name")}`}
                rules={[
                  {
                    required: true,
                    message: "category name is required",
                  },
                ]}
              >
                <InputName maxLength={50} onChange={handleNameChange} />
              </Form.Item>

              <Form.Item
                initialValue={category?.listOrder}
                name="listOrder"
                label={`${t("category-order")}`}
              >
                <InputNumber maxLength={6} />
              </Form.Item>

              <Form.Item
                name="priceSchemeId"
                label={`${t("price-scheme")}`}
                initialValue={category?.price?.id}
              >
                <Select
                  loading={loadingPriceScheme}
                  options={formatedPriceScheme}
                  showSearch={true}
                  optionFilterProp="label"
                  placeholder={t("select-price-scheme")}
                  data-testid="priceScheme"
                />
              </Form.Item>

              <Row>
                <Col span={4}>
                  {isEdit() ? <></> : <Form.Item
                    name="color"
                    label={`${t("color")}`}
                    initialValue={category?.color || "#ffffff"}
                  >
                    <Input
                      autoComplete="off"
                      type="color"
                      value={category?.color}
                    />
                  </Form.Item>}
                </Col>
              </Row>
            </Col>

            <Col offset={2} span={6}>
              <Form.Item
                name="description"
                label={`${t("description")}`}
                initialValue={category?.description}
              >
                <TextArea maxLength={500} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>

      <Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <AddEditButton
            data-testid="add-button"
            disabled={!name}
            onClick={() => {
              setOpen(true);
            }}
            isLoading={""}
          />
        </Col>
      </Row>
      <AddEditModal
        form="categoryForm"
        open={open}
        setOpen={setOpen}
        name={<span> {category?.name}</span>}
        title={`${t("modal-category")}`}
        isSaving={isSaving}
      />
    </>
  );
}

export default AddEditCategory;
